module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-permanents.06ceae74.png";